/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
*/

import { createAction, props } from '@ngrx/store';

import { MongoUser } from '@core/models/mongo';

export const loadUsers = createAction('[Settings:User] Load users data');
export const loadUsersSuccess = createAction(
  '[Settings:User] Load users data Success',
  props<{ users: MongoUser[] }>()
);
export const loadUsersFailure = createAction(
  '[Settings:User] Load users data Failure',
  props<{ errorMessage: string }>()
);

export const createUser = createAction('[Settings:Users] Create user', props<{ user: MongoUser }>());
export const createUserSuccess = createAction('[Settings:Users] Create user success', props<{ user: MongoUser }>());
export const createUserFailure = createAction(
  '[Settings:Users] Create user failure',
  props<{ errorMessage: string }>()
);
export const updateUser = createAction('[Settings:Users] Update user', props<{ user: MongoUser }>());
export const updateUserSuccess = createAction('[Settings:Users] Update user success', props<{ user: MongoUser }>());
export const updateUserFailure = createAction(
  '[Settings:Users] Update user failure',
  props<{ errorMessage: string }>()
);
export const deleteUser = createAction('[Settings:Users] Delete user', props<{ _id?: string }>());
export const deleteUserSuccess = createAction('[Settings:Users] Delete user success', props<{ _id?: string }>());
export const deleteUserFailure = createAction(
  '[Settings:Users] Delete user failure',
  props<{ errorMessage: string }>()
);
export const inviteSuperAdmin = createAction(
  '[Settings:Users] Invite super admin',
  props<{ email: string; tenantId: string }>()
);
